<template>
  <div class="app-page-box">
    <div class="app-page-box__header">
      <app-subtitle v-if="title">{{ title }}<span class="app-page-box__tip" v-if="tip">（{{ tip }}）</span></app-subtitle>
      <slot name="tools"></slot>
    </div>
    <div class="app-page-box__body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import AppSubtitle from '@/components/AppSubtitle'

export default {
  name: 'AppPageBox',
  props: {
    title: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    }
  },
  components: {
    AppSubtitle
  }
}
</script>

<style lang="scss">
.app-page-box {
  padding: 20px;
  margin-bottom: 15px;
  background-color: #fff;

  &:last-child {
    margin-bottom: 0;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__body {
    margin-top: 20px;
  }

  &__tip {
    color: #999;
    font-size: 12px;
  }
}
</style>
